import React from "react";

interface AgeGroupProps {
    title: string;
    description: string[];
}

const AgeGroup: React.FC<AgeGroupProps> = ({ title, description }) => {
    return (
        <article className="max-w-[294px]">
            <h3 className="mb-5 text-3xl font-bold leading-10 text-white max-sm:mb-4 max-sm:text-2xl max-sm:leading-8">
                {title}
            </h3>
            <p className="text-sm leading-5 text-white max-sm:text-sm max-sm:leading-5 text-justify">
                {description.map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        {index < description.length - 1 && <br />}
                    </React.Fragment>
                ))}
            </p>
        </article>
    );
};

export default AgeGroup;
